export default [
  'fetchStoreTemplates',
]


// WEBPACK FOOTER //
// ./src/store/storeTemplates/types.js